import { isBookingRoute, isGuestBookingManageRoute, isProviderAppRoute } from '@/lib/authRoutes'

export type HostKind = 'booking' | 'provider'

export type HostGateResult = { type: 'allow' } | { type: 'marketing' } | { type: 'home' }

/** Strip trailing slashes; empty → undefined. */
export function normalizeOrigin(url: string | undefined | null): string | undefined {
  const trimmed = url?.trim().replace(/\/+$/, '')
  return trimmed && trimmed.length > 0 ? trimmed : undefined
}

export function guestBookingOriginFromEnv(
  env: { VITE_GUEST_BOOKING_ORIGIN?: string } = import.meta.env,
): string | undefined {
  return normalizeOrigin(env.VITE_GUEST_BOOKING_ORIGIN)
}

/**
 * Booking world only when the page origin exactly matches `VITE_GUEST_BOOKING_ORIGIN`.
 * Everything else (app.localhost, app.arrival.hu, bare localhost, …) is provider — no hybrid.
 */
export function resolveHostKind(
  currentOrigin: string = typeof window !== 'undefined' ? window.location.origin : '',
  guestBookingOrigin: string | undefined = guestBookingOriginFromEnv(),
): HostKind {
  const current = normalizeOrigin(currentOrigin)
  const booking = normalizeOrigin(guestBookingOrigin)
  if (booking && current === booking) {
    return 'booking'
  }
  return 'provider'
}

export function resolveHostGate(path: string, kind: HostKind = resolveHostKind()): HostGateResult {
  if (kind === 'booking') {
    if (isBookingRoute(path) || isGuestBookingManageRoute(path)) {
      return { type: 'allow' }
    }
    return { type: 'marketing' }
  }
  if (kind === 'provider' && !isProviderAppRoute(path)) {
    return { type: 'home' }
  }
  return { type: 'allow' }
}

export function redirectToMarketingSite(
  marketingUrl: string | undefined = import.meta.env.VITE_MARKETING_SITE_URL,
  assign: (url: string) => void = (url) => {
    window.location.replace(url)
  },
): void {
  const url = marketingUrl?.trim()
  if (!url) {
    throw new Error('VITE_MARKETING_SITE_URL is not set')
  }
  assign(url)
}
